import './style.css';
import Experience from "./Experience/Experience.js";

const experiense = new Experience(document.querySelector('canvas.webgl'));

// import * as THREE from 'three'
// import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
// import * as dat from 'lil-gui'
// import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
// import waterVertexShader from './shaders/water/vertex.glsl'
// import waterFragmentShader from './shaders/water/fragment.glsl'
// import bladerVertexShader from './shaders/blader/vertex.glsl'
// import bladerFragmentShader from './shaders/blader/fragment.glsl'
// import testVertexShader from './shaders/test/vertex.glsl'
// import testFragmentShader from './shaders/test/fragment.glsl'
// import gsap from 'gsap'
// import { Sky } from './Sky.js';



// /**a
//  * Base
//  */
// // Debug
// const gui = new dat.GUI({ width: 340 })
// const debugObject = {}
// const cameraToBoss = {}
// const cameraToGblokk = {}
// let tid =0;
// let sky = null; 
// // Canvas
// const canvas = document.querySelector('canvas.webgl')

// // Scene
// const scene = new THREE.Scene()

// const sizes = {
//   width: window.innerWidth,
//   height: window.innerHeight
// }

// const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 1000)
// camera.position.set(-50, 50, 100)
// scene.add(camera)
// /**
//  * Water
//  */
// // Geometry

// const restAvfallGrafBoksAlpha = new THREE.BoxGeometry(1.5,15,1.5)
// let restAvfallGrafFargeAlpha = new THREE.MeshStandardMaterial({
//   color: '#00ff00',
//   transparent: true,
//   opacity: 0.25})
// const restAvfallGrafAlpha = new THREE.Mesh(restAvfallGrafBoksAlpha,restAvfallGrafFargeAlpha)

// restAvfallGrafAlpha.position.set(96.556, 1, -10.24579)

// const papirAvfallGrafBoksAlpha = new THREE.BoxGeometry(0.5,7.5,0.5)
// const papirAvfallGrafFargeAlpha = new THREE.MeshStandardMaterial({
//   color: '#ffffff',
//   transparent: true,
//   opacity: 0.25})
// const papirAvfallGrafAlpha = new THREE.Mesh(papirAvfallGrafBoksAlpha, papirAvfallGrafFargeAlpha)
// papirAvfallGrafAlpha.position.set(92.661, 1, -10.24579)

// const GMAvfallGrafBoksAlpha = new THREE.BoxGeometry(0.5,10,0.5)
// const GMAvfallGrafFargeAlpha = new THREE.MeshStandardMaterial({
//   color: '#0000ff',
//   transparent: true,
//   opacity: 0.25})
// const GMAvfallGrafAlpha = new THREE.Mesh(GMAvfallGrafBoksAlpha, GMAvfallGrafFargeAlpha)
// GMAvfallGrafAlpha.position.set(91.8081, 1, -10.24579)
// scene.add(restAvfallGrafAlpha, papirAvfallGrafAlpha, GMAvfallGrafAlpha)


// const restAvfallGrafBoks = new THREE.BoxGeometry(1.5,1,1.5)
// const restAvfallGrafFarge = new THREE.MeshStandardMaterial({color: '#00ff00'})
// const restAvfallGraf = new THREE.Mesh(restAvfallGrafBoks,restAvfallGrafFarge)
// restAvfallGraf.position.set(96.556, 1, -10.24579)

// const papirAvfallGrafBoks = new THREE.BoxGeometry(0.5,2,0.5)
// const papirAvfallGrafFarge = new THREE.MeshStandardMaterial({color: '#ffffff'})
// const papirAvfallGraf = new THREE.Mesh(papirAvfallGrafBoks, papirAvfallGrafFarge)
// papirAvfallGraf.position.set(92.661, 1, -10.24579)

// const GMAvfallGrafBoks = new THREE.BoxGeometry(0.5,3,0.5)
// const GMAvfallGrafFarge = new THREE.MeshStandardMaterial({color: '#0000ff'})
// const GMAvfallGraf = new THREE.Mesh(GMAvfallGrafBoks, GMAvfallGrafFarge)
// GMAvfallGraf.position.set(91.8081, 1, -10.24579)

// scene.add(restAvfallGraf, papirAvfallGraf, GMAvfallGraf) 

// gui.add(restAvfallGraf.scale,'y',).min(1).max(15).step(0.1).name('rest')

// if(restAvfallGraf.scale.y> 10){
//   restAvfallGrafAlpha.material.color = 0xffa200
//   console.log('restAvfallGrafAlpha')
// }

// //Color

// debugObject.surfaceColor = '#4b2901'
// debugObject.bladerColor = '#064b01'

// // Material
// const testMaterial = new THREE.ShaderMaterial({
//   uniforms: {
//     uTime: {value: 2.0},
//     uAlpha: {value: 0.5},
//     uMultiplier: {value: 300.0},
//     uColor1: {value: new THREE.Color(`rgb(0,0,255)`)},
//     uColor2:{value: new THREE.Color(`rgb(255,234,0)`)}
//   },
//   fragmentShader: testFragmentShader, 
//   vertexShader: testVertexShader,
//   side: THREE.DoubleSide,
// })


// const waterMaterial = new THREE.ShaderMaterial({
//     vertexShader: waterVertexShader,
//     fragmentShader: waterFragmentShader,
//     transparent: true,
//     side: THREE.DoubleSide,
//     uniforms:{
//         uTime: {value: tid},
//         uBigWavesElevation: {value: 0.2},
//         uBigWavesFrequency: {value: new THREE.Vector2(1.5,2)},
//         uBigWaveSpeed: {value: 0.75},

//         uSmallWavesElevation: {value: 0.15},
//         uSmallWavesFrequency: {value: 1.0},
//         uSmallWavesSpeed: {value: 0.2},
//         uSmallWavesIterations: {value: 5.0},

       
//         uSurfaceColor: {value: new THREE.Color(debugObject.surfaceColor)},
//         uColorOffset: {value: 0.08},
//         uColorMultiplier: {value: 5}
//     }
    
// })
// const bladerMaterial = new THREE.ShaderMaterial({
//   vertexShader: bladerVertexShader,
//   fragmentShader: bladerFragmentShader,
//   transparent: true,
//   side: THREE.DoubleSide,
//   uniforms:{
//       uTime: {value: tid},
//       uBigWavesElevation: {value: 0.2},
//       uBigWavesFrequency: {value: new THREE.Vector2(1.5,2)},
//       uBigWaveSpeed: {value: 0.75},

//       uSmallWavesElevation: {value: 0.15},
//       uSmallWavesFrequency: {value: 1.0},
//       uSmallWavesSpeed: {value: 0.2},
//       uSmallWavesIterations: {value: 5.0},

     
//       ublalderColor: {value: new THREE.Color(debugObject.bladerColor)},
//       uColorOffset: {value: 0.08},
//       uColorMultiplier: {value: 5}
//   }
  
// })

// gui.add(testMaterial.uniforms.uAlpha, 'value',).min(0).max(1).step(0.1).name('uAlpha')
// gui.add(testMaterial.uniforms.uTime, 'value',).min(0).max(10).step(0.1).name('uTime')
// gui.add(testMaterial.uniforms.uMultiplier, 'value',).min(0).max(500).step(1).name('uMultiplier')




// gui
// .addColor(debugObject, 'surfaceColor')
// .name('surfaceColor')
// .onChange(()=>{
//     waterMaterial.uniforms.uSurfaceColor.value.set(debugObject.surfaceColor)
// })
// gui
// .addColor(debugObject, 'bladerColor')
// .name('bladerColor')
// .onChange(()=>{
//     bladerMaterialMaterial.uniforms.uSurfaceColor.value.set(debugObject.surfaceColor)
// })


// const options = {
//   enableSwoopingCamera: false,
//   enableRotation: true,
//   transmission: 1,
//   thickness: 1.5,
//   roughness: 0.07,
//   envMapIntensity: 1.5
// };

// const glass = new THREE.MeshPhysicalMaterial({
//   transmission: options.transmission,
//   thickness: options.thickness,
//   roughness: options.roughness,
  
// });

// const raycaster = new THREE.Raycaster();
// const rayOrgin = new THREE.Vector3(camera.position);
// const rayDirection = new THREE.Vector3(camera.direction)
// rayDirection.normalize();

// const mouse = new THREE.Vector2()
// window.addEventListener('click', (event)=>{
//   mouse.x = event.clientX / sizes.width * 2 - 1
//   mouse.y = - (event.clientY / sizes.height) * 2 + 1
//   console.log(mouse.x,mouse.y)

  
// })

// const gltfLoader = new GLTFLoader();
// let model = null

// gltfLoader.load("terreng2.glb", (gltf) => {
  
//   model = gltf.scene;

//   gltf.scene.traverse(function (child) {
//     if (child.isMesh) {
      
//       child.castShadow = true;
//       child.receiveShadow = true;
      
//     }
//   });

//   console.log(model);
//   model.children[53].material = testMaterial;
//   model.children[54].material = testMaterial;
//   model.children[55].material = testMaterial;
//   model.children[56].material = testMaterial;
//   model.children[89].material = glass;
//   model.children[54].material.transparent = true;
//   model.children[54].material.depthTest = false;
//   model.children[53].material.transparent = true;
//   model.children[53].material.depthTest = false;
//   model.children[55].material.transparent = true;
//   model.children[55].material.depthTest = false;
//   model.children[56].material.transparent = true;
//   model.children[56].material.depthTest = false;
  


//   scene.add(gltf.scene);
 
// });

// /**
//  * Sizes
//  */

// window.addEventListener('resize', () =>
// {
//     // Update sizes
//     sizes.width = window.innerWidth
//     sizes.height = window.innerHeight

//     // Update camera
//     camera.aspect = sizes.width / sizes.height
//     camera.updateProjectionMatrix()

//     // Update renderer
//     renderer.setSize(sizes.width, sizes.height)
//     renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
// })

// /**
//  * Camera
//  */
// // Base camera


// const lys = new THREE.DirectionalLight( 0xffffff,2 )
// const skygge = new THREE.AmbientLight( 0xffffff,.5 )
// lys.shadow.camera.top = 75
// lys.shadow.camera.right = 75
// lys.shadow.camera.bottom = - 75
// lys.shadow.camera.left = - 75
// lys.shadow.mapSize.width = 1024;
// lys.shadow.mapSize.height = 1024;
// lys.position.set(-50,150,100)
// lys.target.position.set(100,0,1)
// lys.shadow.bias=-0.004;
// lys.castShadow = true
// scene.add(lys, skygge, lys.target)

// const lys2 = new THREE.DirectionalLight( 0xffffff,1.25 )
// lys2.shadow.camera.top = 75
// lys2.shadow.camera.right = 75
// lys2.shadow.camera.bottom = - 75
// lys2.shadow.camera.left = - 75
// lys2.shadow.mapSize.width = 1024;
// lys2.shadow.mapSize.height = 1024;
// lys2.position.set(190,150,0)
// lys2.target.position.set(100,0,1)
// lys2.shadow.bias=-0.004;
// lys2.castShadow = true
// //scene.add(lys2, lys2.target)


// const lyshjelp = new THREE.CameraHelper(lys.shadow.camera)
// scene.add(lyshjelp) 
// lyshjelp.visible = false

// // Controls
// const controls = new OrbitControls(camera, canvas)
// controls.enableDamping = false

// /**
//  * Renderer
//  */
// const renderer = new THREE.WebGLRenderer({
//     canvas: canvas
// })
// renderer.setSize(sizes.width, sizes.height)
// renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
// renderer.setClearColor('#9bd8ff')
// renderer.shadowMap.enabled = true




// const spotLight = new THREE.SpotLight( 0xffffff, 3 );
// 				spotLight.position.set(99.2, 2.96, -16.8);
// 				spotLight.angle = Math.PI / 3;
//         spotLight.target.position.set(99.2, 0, -16.8);
// 				spotLight.penumbra = 1;
// 				spotLight.decay = 2;
// 				spotLight.distance = 0;
//         spotLight.shadow.bias=-0.004;

// 				spotLight.castShadow = true;
// 				spotLight.shadow.mapSize.width = 1024;
// 				spotLight.shadow.mapSize.height = 1024;
// 				spotLight.shadow.camera.near = 0.1;
// 				spotLight.shadow.camera.far = 5;
// 				spotLight.shadow.focus = 1;
// 				scene.add( spotLight );
//         scene.add( spotLight.target );

			
// const spotLight2 = new THREE.SpotLight( 0xffffff, 3 );
// 				spotLight2.position.set(99, 5.96, -7.478);
// 				spotLight2.angle = Math.PI / 3;
//         spotLight2.target.position.set(99, 0, -7.478);
// 				spotLight2.penumbra = 1;
// 				spotLight2.decay = 2;
// 				spotLight2.distance = 0;


// 				spotLight2.castShadow = true;
// 				spotLight2.shadow.mapSize.width = 1024;
// 				spotLight2.shadow.mapSize.height = 1024;
// 				spotLight2.shadow.camera.near = 0.1;
// 				spotLight2.shadow.camera.far = 5;
// 				spotLight2.shadow.focus = 1;
// 				scene.add( spotLight2 );
//         scene.add( spotLight2.target );




// /**
//  * Animate
//  */

// function rotateCamera(x, y, z, duration){
//   gsap.to(camera.rotation,{
//     x,
//     y,
//     z,
//     duration 
//   })
  
// }

// const kameraToBoss = gsap 
// cameraToBoss.kameraToBoss = ()=>{
//   kameraToBoss.to(camera.position, {
//     x: 62,
//     y: 22,
//     z: 23,
//     duration: 10.0,
    
//     onUpdate: function(){
//       camera.lookAt(86.556, -0.66, -10.94579)
//     }
//   })
//   rotateCamera(-0.59, -0.54, -0.33, 10)
// }

// const kameraToGblokk = gsap 
// cameraToGblokk.kameraToGblokk = ()=>{
//   kameraToGblokk.to(camera.position, {
//     x: 99,
//     y: 30,
//     z: -12,
//     duration: 10.0,
    
//     onUpdate: function(){
//       camera.lookAt(136, 18, 34)
//     }
//   })
//   rotateCamera(-2.9, -0.66, -2.98, 10)
// }
// gui.add(cameraToBoss, 'kameraToBoss').name('Miljøstasjon')
// gui.add(cameraToGblokk, 'kameraToGblokk').name('G-Blokk')

// const clock = new THREE.Clock()

// const tick = () =>
// {
//     const elapsedTime = clock.getElapsedTime()

//     raycaster.setFromCamera(mouse, camera)

//     //update water
//     tid = testMaterial.uniforms.uTime.value = elapsedTime * 2
//     waterMaterial.uniforms.uTime.value = elapsedTime * 2
//     bladerMaterial.uniforms.uTime.value = elapsedTime * 2
    
    

//     // Update controls
//     //controls.update()

//     // Render
//     renderer.render(scene, camera)

//     // Call tick again on the next frame
//     window.requestAnimationFrame(tick)
// }

// tick()